import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Routes } from '../frame';
import { CRMConfig } from './types';
import { CRMContextProvider } from './CRMContext';
import { ContactsPage } from './ContactsPage';
import { OrganizationsPage } from './OrganizationsPage';
import { TagsPage } from './TagsPage';
import { CRMTagsContextProvider } from './CRMTagsContext';
import { CRMStyles } from './Elements/CRMStyles';
import { SettingsPage } from './SettingsPage';

interface Props extends Omit<CRMConfig, "pagePath"> {
}

export const CRMRoutes = (props: Props) => {
  let { path } = useRouteMatch();
  
  return (
    <CRMContextProvider pagePath={path} {...props}>
      <CRMStyles />
      <CRMTagsContextProvider>
        <Routes
          routes={[
            { path: `${path}/organization`, component: OrganizationsPage },
            { path: `${path}/tag`, component: TagsPage },
            { path: `${path}/settings`, component: SettingsPage },
            { path: `${path}/`, component: ContactsPage },
          ]}
        />
      </CRMTagsContextProvider>
    </CRMContextProvider>
  );
}
